$("document").ready(function () {
    var bodyH = $(window).outerHeight();
    var contentHight = bodyH - 150;
    var overlay = $('.overlay_bg');
    if ($(".navbar-main").length) {
        $(".navbar-main")
            .mouseenter(function () {
                overlay.addClass('activate');
                overlay.height(contentHight);
            })
            .mouseleave(function () {
                overlay.removeClass('activate');
                overlay.css("height", "unset");
            });
    }

    $(".main-list")
        .mouseenter(function () {
            overlay.addClass('activate');
            overlay.height(contentHight);
        })
        .mouseleave(function () {
            overlay.removeClass('activate');
            overlay.css("height", "unset");
        });


});

